import { useIntl } from '@capsicum/common';
import { ModalService, RadioButtonInput } from '@capsicum/common-web';
import { useAmlPep } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';
import { PepModal } from './PepModal';
import { PepWarningModal } from './PepWarningModal';

export const Pep = () => {
	const { $t } = useIntl();
	const { options, questionValue, setQuestionValue } = useAmlPep();

	const handleRadioGroup = (id: boolean) => {
		if (id) {
			ModalService.addModal({
				renderComponent: ({ close }) => (
					<PepWarningModal
						onConfirm={e => {
							setQuestionValue(e);
							close();
						}}
					/>
				)
			});

			return;
		}
		setQuestionValue(id);
	};
	const handleLink = () => {
		ModalService.addModal({
			renderComponent: () => <PepModal />
		});
	};

	return (
		<S.Wrapper>
			<S.Wrapper>
				<S.Question>{$t('amlQuestionnaire.fifthStep.question')}</S.Question>
				<S.ReadMore onClick={handleLink}>{$t('amlQuestionnaire.fifthStep.learnMore')}</S.ReadMore>
			</S.Wrapper>
			<S.RadioButtonsContainer>
				{options.map((item, index) => (
					<S.RadioButtonWrapper key={item.label}>
						<RadioButtonInput
							checked={item.id === questionValue}
							item={item}
							pressableLabels
							testID={`aml-questionnaire-PEP-radiobox${index + 1}`}
							onPress={() => handleRadioGroup(item.id)}
						/>
					</S.RadioButtonWrapper>
				))}
			</S.RadioButtonsContainer>
		</S.Wrapper>
	);
};
